import React, { useEffect, useState } from 'react';
import { createContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import "../../stylesheets/detailsForm.css";
import { Combobox, DateInput, PaginatedSelect, PaginatedSelect2, TextField } from '../layout/form/TextInputFields';
import { FormContext, useFormValidation } from '../contexts/FormContext';
import ModifiedForm from '../layout/form/ModifiedForm';
import { getPagenatedCategories, getPermCategories, getPermJobs, sendSign } from '../../api/branchesRequests';
import { getBranches, getPaginatedBranches } from '../../api/branchesRequests';
import axiosInstance from '../../api/axiosInstance';
import ErrorHandler from "../../error-handler/ErrorHandler"
import { Select } from 'antd';
import { usePageContext } from '../contexts/ScanContext';


function ModifiedSelect({ id, title, dataFunction, queryTitle }) {

    const [branches, setbranches] = useState([]);
    const [branchesNext, setbranchesNext] = useState(1);

    function initData() {
        dataFunction().then(res => {

            console.log(res.data)

            setbranches(res.data);
            setbranchesNext(res.next);

        });
    }

    useEffect(() => {

        initData();


    }, [])



    return (

        <PaginatedSelect
            id={id}
            title={title}
            className="formTextField"
            loadNext={() => {
                branchesNext && dataFunction(branchesNext).then(res => {
                    console.log(res)
                    setbranches([...branches, ...res.data]);
                    setbranchesNext(res.next);
                })
            }}>
            {branches && branches?.map(e => <Select.Option key={e.id} value={e.id}>{e[queryTitle]}</Select.Option>)}
        </PaginatedSelect>
    )
}
function DetailsForm({ croppedImages, validation, submitFunction, id }) {


    const { t } = useTranslation();


    const [categories, setcategories] = useState([]);
    const [jobs, setjobs] = useState([]);
    
    // const { croppedImages } = usePageContext();

    async function submit(data) {

        try {
            data.signature_en = croppedImages[0];
            data.signature_ar = croppedImages[1];

            submitFunction(data, id);
            return { type: 1, message: t("success") }
        }
        catch (e) {
            console.error(e);
            return { type: 2, message: e.message }
        }
    }


    return (
        <ModifiedForm submitFunction={submit}>
            <div className="styledform">

                <TextField
                    className="formTextField"
                    id={"signee_name_ar"}
                    title={t("form.nameAR")}
                    validation={validation}
                />
                <TextField
                    className="formTextField"
                    id={"signee_name_en"}
                    title={t("form.nameEN")}
                    validation={validation}

                />


                <ModifiedSelect 
                id={"bank_branch"}
                 title={t("form.branch")}
                  dataFunction={getPaginatedBranches} 
                  queryTitle={"name_en"} 
                  validation={validation}
                  />

                <ModifiedSelect 
                id={"category"} 
                title={t("form.category")} 
                dataFunction={getPermCategories}
                 queryTitle={"title_en"} 
                 validation={validation}

                 />

                <ModifiedSelect 
                id={"job"} 
                title={t("form.job")} 
                dataFunction={getPermJobs} 
                queryTitle={"title_en"} 
                validation={validation}
                />



                <DateInput
                    className="formTextField"
                    id={"avaliable_from"}
                    title={t("form.available")}
                    validation={validation}

                />

            </div>

            <div className="formSubmit">
                <button className="defaultButton" type="submit" >
                    {t("buttons.finish")}
                </button>
            </div>
        </ModifiedForm>
    )
}

export default ErrorHandler(DetailsForm, axiosInstance);